import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { LocalStorageService } from '../shared/services/localstorage.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private toaster: ToastrService,
    private localStorageService: LocalStorageService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error) {
          switch (error.status) {
            case 400:
              if (error.error.errors) {
                const modelStateErrors = [];
                for (const key in error.error.errors) {
                  if (error.error.errors[key]) {
                    modelStateErrors.push(error.error.errors[key]);
                  }
                }
                // throw modelStateErrors.flat();
              } else if (typeof error.error === 'object') {
                this.toaster.error(error.error.title ?? error.error.message);
              } else {
                this.toaster.error('', error.error, error.status); //todo: check what message header is be shown
              }
              break;
              case 401:
                this.toaster.error('Not Authorize', error.status);
                const data = this.localStorageService.getLocalData('UserDetail')
                if (data) {
                  window.location.href = data.redirectURL;
                } else {
                  this.toaster.error('Not Authorize', error.status);
                }
                let valueToRetail: string[] = [];
                valueToRetail.push('OrgGroupId', 'ColorChanger', 'BtnColorChanger');
                this.localStorageService.clearLocalData(valueToRetail)
    
                break;
            case 404:
              break;
            case 500:
              this.toaster.error(error.error.message);
              break;
            default:
              this.toaster.error('Something unexpected wrong!');
              console.log(error);
              break;
          }
        }
        return throwError(() => new Error('test'));
      })
    );
  }
}